import { Tree } from "src/types/tree.types";
import { EditorState } from "../types/editor-state.types";
import { createPositionsFromTree } from "./position.helpers";

export function buildEditorStateFromTree(
  tree: Tree,
  autoFocus = false
): EditorState {
  const state: EditorState = {
    canvasView: { x: -50, y: -50 },
    focusedNodeId: autoFocus ? tree.nodes[0]?.node.id : undefined,
    positions: createPositionsFromTree(tree),
    nodes: tree.nodes.reduce(
      (acc, treeNode) =>
        Object.assign(acc, { [treeNode.node.id]: treeNode.node }),
      {}
    ),
  };

  return state;
}
